import { render, staticRenderFns } from "./EmblavementsActionsComponent.vue?vue&type=template&id=56801e63"
import script from "./EmblavementsActionsComponent.vue?vue&type=script&lang=js"
export * from "./EmblavementsActionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports